import React, { Component } from 'react';
import { DatePicker, List, Modal, WhiteSpace, Toast } from 'antd-mobile';
import F2 from '@antv/f2';
import df from 'dateformat';
import { ROOT_PATH } from '../../config';
import send from '../../utils/send';
import Table from '../../components/Table';
import RealTimeDetail from './realtimeDetail';
import EmptyReport from '../../components/EmptyReport';

const today = new Date();
let clientWidth = document.documentElement.clientWidth;
let stageToColor = {
  选种: '#FF3B30',
  后备种猪: '#31C0B0',
  配种: '#1890FF',
  流产: '#834CCF',
  返情: '#F2E129',
  空怀: '#F5A911',
  分娩: '#FE5578',
  断奶: '#897DEC',
  转入: '#1DA834'
};
let already = 0;

class RealTime extends Component {
  constructor(props) {
    super(props);

    var realtimeChart = null;

    this.state = {
      modalShow: false,
      modalHeader: '',
      modalContent: null,
      date: today,
      hasRealTimeData: true,
      data: [],
      columns: [
        {
          id: 'target',
          title: '指标',
          align: 'left',
          render: (data, index, item) => {
            return (
              <span
                style={{ color: '#108EE9' }}
                onClick={() => {
                  this.setState({
                    modalShow: true,
                    modalContent: <RealTimeDetail data={data} />
                  });
                }}
              >
                {data.target}
              </span>
            );
          }
        },
        {
          id: 'qty',
          title: '数量',
          align: 'right'
        },
        {
          id: 'rate',
          title: '占比',
          align: 'right'
        }
      ]
    };
  }

  // 获取母猪实时状态数据
  getData = (date) => {
    send(`${ROOT_PATH}/api/forward/ifarm/realtime-pig`, {
      method: 'POST',
      data: {
        startDate: date,
        endDate: date,
        dateToday: date,
        gdType: ['D000301'],
        gdCode: ['1001'],
        command: 'getCommand1',
        startsWith: '1',
        datasFlag: '2'
      }
    })
      .then((res) => {
        already++;
        this.parseData(res.data);
      })
      .catch((execption) => {
        return execption;
      });
  };

  // 获取指标表格数据
  getTableData = (date) => {
    send(`${ROOT_PATH}/api/forward/ifarm/realTimeStateTable`, {
      method: 'POST',
      data: {
        startDate: date,
        endDate: date,
        dateToday: date,
        gdType: ['D000301'],
        gdCode: ['2001', '3001', '4001', '5001', '6001', '7001', '8001'],
        command: 'getCommand1',
        startsWith: '1'
      }
    })
      .then((res) => {
        already++;
        this.updateTableData(res.data);
      })
      .catch((execption) => {
        return execption;
      });
  };

  updateTableData(data) {
    let dataSource = [];
    data.map((obj) => {
      let newObj = {};
      newObj['target'] = obj.descLoc;
      newObj['qty'] = obj.datas[0].VAL_QTY !== undefined ? obj.datas[0].VAL_QTY : '-';
      newObj['rate'] = obj.datas[0].VAL_RATE !== undefined ? obj.datas[0].VAL_RATE : '-';
      newObj['gdType'] = obj.gdType;
      newObj['gdCode'] = obj.gdCode;
      newObj['date'] = df(this.state.date, 'yyyy-mm-dd');
      dataSource.push(newObj);
    });
    this.setState({
      data: dataSource
    });
  }

  // 绘制报表 -- 母猪实时状态
  parseData(data) {
    if (!data || data.length === 0) {
      this.setState({ hasRealTimeData: false });
      return;
    }
    this.setState({ hasRealTimeData: true });

    this.drawReport(data);
  }

  drawReport = (data) => {
    let stageArray = Object.keys(stageToColor);
    data.sort((obj1, obj2) => {
      const stage1 = obj1.DESC_LOC.split(' ')[0];
      const stage2 = obj2.DESC_LOC.split(' ')[0];
      let index1 = stageArray.indexOf(stage1);
      let index2 = stageArray.indexOf(stage2);
      return index1 - index2;
    });

    let chart = this.realtimeChart;
    if (chart) {
      chart.clear();
    } else {
      chart = new F2.Chart({
        id: 'mountNode',
        plugins: require('@antv/f2/lib/plugin/pie-label'),
        pixelRatio: window.devicePixelRatio
      });
    }

    this.realtimeChart = chart;

    chart.source(data);

    chart.coord('polar', {
      transposed: true,
      radius: 0.75,
      innerRadius: 0.43
    });

    chart.axis(false);
    chart.tooltip(false);

    chart.legend({
      position: 'top',
      align: 'center',
      itemWidth: 40,
      itemGap: 44,
      marker: {
        radius: 5
      },
      titleStyle: {
        fill: '#666',
        fontSize: 14
      },
      itemFormatter: function itemFormatter(val) {
        const values = val.split(' ');
        return values[0];
      }
    });

    chart.pieLabel({
      sidePadding: 15,
      activeShape: true,
      lineHeight: 45,
      label1OffsetY: -3,
      label2OffsetY: 2,
      label1: function label1(data) {
        return {
          text: data.DESC_LOC.split(' ')[0],
          fill: '#999999',
          fontSize: 10
        };
      },
      label2: function label2(data) {
        return {
          text: data.VAL + ' 头' + ' (' + data.DESC_LOC.split(' ')[1] + ')',
          fill: '#666666',
          fontSize: 10
        };
      }
    });

    chart
      .interval()
      .position('"const"*VAL')
      .adjust('stack')
      .color('DESC_LOC', function(item) {
        let stage = item.split(' ')[0];
        let color = stageToColor[stage];
        return color ? color : '#FF3B30';
      });
    chart.render();

    // 绘制内阴影
    var frontPlot = chart.get('frontPlot');
    var coord = chart.get('coord'); // 获取坐标系对象
    frontPlot.addShape('sector', {
      attrs: {
        x: coord.center.x,
        y: coord.center.y,
        r: coord.circleRadius * coord.innerRadius * 1.24, // 全半径
        r0: coord.circleRadius * coord.innerRadius,
        fill: '#000',
        opacity: 0.15
      }
    });
    chart.get('canvas').draw();
  };

  doSearch = (date) => {
    already = 0;
    Toast.loading('加载中...', 0);

    var d = df(date || new Date(), 'yyyy-mm-dd');
    this.getData(d);
    this.getTableData(d);
  };

  componentDidMount() {
    window._czc.push(['_trackEvent', '进入母猪实时状态页面']);
    this.doSearch();
  }

  componentDidUpdate() {
    if (already === 2) {
      Toast.hide();
    }
  }

  componentWillUnmount() {
    Toast.hide();
    this.setState = () => {};
  }

  render() {
    return (
      <React.Fragment>
        <DatePicker
          extra="Optional"
          mode="date"
          onChange={(date) => {
            this.setState({ date });
            this.doSearch(date);
          }}
          title="日期"
          value={this.state.date}
        >
          <List.Item arrow="horizontal">选择日期</List.Item>
        </DatePicker>
        <List renderHeader={() => ''}>
          {this.state.hasRealTimeData ? (
            <canvas id="mountNode" height={330} width={clientWidth} />
          ) : (
            <EmptyReport height={330} width={clientWidth} />
          )}
        </List>
        <List renderHeader={() => ''}>
          <List.Item>状态详细信息</List.Item>
          <Table columns={this.state.columns} data={this.state.data} />
        </List>
        <WhiteSpace size="xl" />
        {/*弹出层公用模态框、*/}
        <Modal
          animationType="slide-up"
          maskClosable={false}
          closable
          onClose={() => {
            this.setState({
              modalShow: false
            });
          }}
          popup
          visible={this.state.modalShow}
        >
          {this.state.modalContent}
        </Modal>
      </React.Fragment>
    );
  }
}

export default RealTime;
